import { gql } from "@apollo/client"
import { MutationUpdateEmploymentArgs, UpdateEmploymentPayload } from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"

const STAFF_UPDATE_EMPLOYMENT_TERMINATION_DETAILS = gql`
  mutation StaffUpdateEmploymentTerminationDetails($input: UpdateEmploymentInput!) {
    updateEmployment(input: $input) {
      engagement {
        id
        termination {
          mutualTermination
          serviceAgreementSignature
          additionalNotesForDepositTeam
          staffDepositNote
          additionalConsiderationAmountToBeConfirmed
          additionalConsiderationAmount {
            subunit
            subunitToUnit
            currencyCode
          }
        }
      }
      errors
    }
  }
`

export default (
  options?: InjectedOptions<
    { updateEmployment: UpdateEmploymentPayload },
    MutationUpdateEmploymentArgs
  >,
) => useMutation(STAFF_UPDATE_EMPLOYMENT_TERMINATION_DETAILS, options)
